"use server";

import { cookies } from "next/headers";
import { createServerAction } from "@/lib/actions/create-server-action";
import { sessionCookieDeletion } from "@/lib/auth/session-cookie-options";
import { SESSION_EXPIRED_COOKIE_NAME } from "@/lib/auth/session-expired-cookie";

/** Clears the shared expiry marker after a browser tab verifies fresh credentials. */
export const clearSessionExpiredMarkerAction = createServerAction({
  id: "clear-session-expired-marker",
  description: "Clears the cross-tab session expiry marker",
  handler: async () => {
    const cookieStore = await cookies();
    cookieStore.delete(sessionCookieDeletion(SESSION_EXPIRED_COOKIE_NAME));
    return {};
  },
});
